var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import Form from 'antd/lib/form';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';
var Option = Select.Option;
import 'src/imports/styles/extend.form.scss';
var TIER_FREE = '0';
var TIER_PAID = '1';
var InputPayment = function (props) { return (React.createElement(Form.Item, { label: props.initialValue === undefined ? 'Select a plan for your event' : 'Your event\'s plan', colon: false }, props.form.getFieldDecorator('paymentTier', {
    initialValue: String(props.initialValue !== undefined ? props.initialValue : TIER_FREE),
    rules: [{
            required: true,
            message: 'Please pick a plan for your event!',
        }],
})(React.createElement(React.Fragment, null,
    React.createElement(Select, { size: 'large', defaultValue: String(TIER_FREE), value: String(props.initialValue || props.form.getFieldValue('paymentTier')), disabled: props.isDisabled || props.initialValue !== undefined, onChange: function (value) {
            props.form.setFieldsValue({
                paymentTier: value.toString(),
            });
        } },
        React.createElement(Option, { value: TIER_FREE }, "Free"),
        React.createElement(Option, { value: TIER_PAID }, "Paid")),
    React.createElement("div", null, props.form.getFieldValue('paymentTier') === undefined
        ? null
        : props.form.getFieldValue('paymentTier') === TIER_PAID
            ? (React.createElement(ListPaymentTierDetails, null,
                React.createElement("ul", null,
                    React.createElement("li", null, "Event URL is fully customizable"),
                    React.createElement("li", null, "No limit on athletes in event"),
                    React.createElement("li", null, "Lots of help from the CRIMP team")),
                props.initialValue === undefined
                    ? React.createElement("h4", null,
                        "Please contact us at ",
                        React.createElement("a", { href: 'mailto:hello@crimp.rocks' }, "hello@crimp.rocks"),
                        " after creating your event to upgrade to the Paid Tier")
                    : React.createElement("h4", null,
                        "Thank you for supporting CRIMP! Email us at ",
                        React.createElement("a", { href: 'mailto:hello@crimp.rocks' }, "hello@crimp.rocks"),
                        " if you need help!")))
            : (React.createElement(ListPaymentTierDetails, null,
                React.createElement("ul", null,
                    React.createElement("li", null, "Event URL starts with \"free-\""),
                    React.createElement("li", null, "Limited to 100 athletes"),
                    React.createElement("li", null, "Lots of help from the CRIMP team")),
                props.initialValue === undefined
                    ? React.createElement("h4", null, "Feel free to use the Free Tier to run your events!")
                    : React.createElement("h4", null,
                        "Feel free to email us at ",
                        React.createElement("a", { href: 'mailto:hello@crimp.rocks' }, "hello@crimp.rocks"),
                        " for help or to upgrade to Paid Tier")))))))); };
var ListPaymentTierDetails = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  line-height: 1.4;\n\n  ul {\n    padding-left: 2rem;\n    margin: 2rem 0;\n  }\n\n  li {\n    margin-bottom: 1rem;\n  }\n"], ["\n  line-height: 1.4;\n\n  ul {\n    padding-left: 2rem;\n    margin: 2rem 0;\n  }\n\n  li {\n    margin-bottom: 1rem;\n  }\n"])));
export default InputPayment;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormEventPage/FormEvent/InputPayment.tsx
// module id = 1159
// module chunks = 0